import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import loggingReducer from './reducers/loggingSlice';
import packetDataReducer from './reducers/packetDataSlice';
import projectIdReducer from './reducers/projectIdSlice';
import testReducer from './reducers/testSlice';
import userReducer from './reducers/userSlice';

export const store = configureStore({
  reducer: {
    logging: loggingReducer, //New, trying to manage error logging at the redux level
    packetData: packetDataReducer,
    projectId: projectIdReducer,
    test: testReducer,
    user: userReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
